module.exports = __webpack_public_path__ + "static/media/exampleBg.46d0db78.jpg";